import { Pipe, PipeTransform } from '@angular/core';
import { isNullOrUndefined } from '@timechef/core/utils/js-utils';

@Pipe({
  name: 'isNotNullorUndefined',
  standalone: false,
})
export class IsNotNullorUndefinedPipe implements PipeTransform {
  transform(value: any | null | undefined): boolean {
    return !isNullOrUndefined(value);
  }
}
